<script setup>
import { useFetch } from "vutil";

const props = defineProps(["id"]);

const monthFmt = new Intl.DateTimeFormat("nb-NO", { month: "long" });
const numFmt = new Intl.NumberFormat("nb-NO", { style: "currency", currency: "NOK" });

const { data, error } = useFetch(`/api/site/${props.id}/payouts`, data =>
{
	const map = new Map();

	for (const payout of data) {
		let year = map.get(payout.year);

		if (!year) {
			year = { payouts: [] };
			map.set(payout.year, year);
		}

		year.payouts.push(payout);
	}

	return map;
});
</script>

<template>
	<div class="error">{{ error }}</div>
	<template v-if="data">
		<div v-if="data.size === 0" class="list">
			<div>Ingen utbetalinger registrert</div>
		</div>
		<template v-for="[key, year] in data" :key="key">
			<h2>{{ key }}</h2>
			<div class="list">
				<a v-for="po in year.payouts" :key="po.num" :href="`/api/payout/${id}/${po.num}`" class="payout">
					<div class="num">{{ po.num }}</div>
					<div class="month">{{ monthFmt.format(new Date(po.year, po.month - 1)) }}</div>
					<div>{{ numFmt.format((po.amount - po.fee + po.vat) / 100) }}</div>
				</a>
			</div>
		</template>
	</template>
</template>
